import { TextField } from "@mui/material";

export default function AppTextField({
    placeholder,
    onChange,
    dir,
    value,
    ...otherProps
}) {
    return (
        <>
            <TextField
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                size="small"
                dir={dir}
                fullWidth
                sx={{
                    ".MuiFormHelperText-root": {
                        ...(dir == "rtl"
                            ? {
                                  textAlign: "left",
                                  marginLeft: 0,
                              }
                            : {
                                  textAlign: "right",
                                  marginRight: 0,
                              }),
                    },
                    ".MuiInputLabel-asterisk": {
                        color: "red",
                    },
                }}
                {...otherProps}
            />
        </>
    );
}
